import { render, staticRenderFns } from "./GblOrgList.vue?vue&type=template&id=15116d5d"
import script from "./GblOrgList.vue?vue&type=script&lang=js"
export * from "./GblOrgList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports